// material-ui
import withStyles from "@material-ui/core/styles/withStyles";
import moment from "moment";
import PropTypes from "prop-types";
import React, { Component } from "react";
import Chart from "react-apexcharts";
// styles
import styles from "./styles";

class DatetimeGraph extends Component {
  static propTypes = {
    data: PropTypes.array,
    dataKey: PropTypes.string,
    dateKey: PropTypes.string,
    height: PropTypes.number,
    color: PropTypes.string,
  };

  constructor(...args) {
    super(...args);
    const { data } = this.props;
    this.state = {
      graph: moment(data[0].paymentDate).diff(
        moment(data[data.length - 1].paymentDate),
        "days"
      ),
    };
  }

  getGraphConfig(range) {
    const { data, dataKey, dateKey, height, color } = this.props;
    const graphData = [];
    const colors = [];

    const currentDay = moment(data[0].paymentDate);
    for (let index = 0; index < range; index++) {
      graphData.push([currentDay.toDate().getTime(), 0]);
      currentDay.subtract(1, "d");
    }

    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const element = data[key];
        const now = moment(data[0].paymentDate); // todays date
        const end = moment(element[dateKey]); // another date
        const duration = moment.duration(now.diff(end));
        const days = Math.round(duration.asDays());
        if (graphData[days]) {
          graphData[days][1] += element[dataKey] / 100;
          colors.push("#777777");
        }
      }
    }

    const options = {
      chart: {
        height: height || 200,
      },
      colors: [color || "#FF7F00"],
      stroke: {
        width: 0,
        curve: "smooth",
      },
      dataLabels: {
        enabled: false,
      },
      fill: {
        opacity: 1,
        type: "solid",
      },
      yaxis: {
        tickAmount: 3,
        labels: {
          show: false,
        },
      },
      xaxis: {
        type: "datetime",
      },
    };
    const series = [
      {
        name: "Invoice",
        data: graphData,
      },
    ];

    const config = { options, series, type: "bar" };
    return config;
  }

  render() {
    const { height, color } = this.props;
    const { graph } = this.state;
    const config = this.getGraphConfig(graph);

    return (
      <div>
        <Chart
          options={config.options}
          series={config.series}
          type={config.type}
          height={height || 200}
        />
      </div>
    );
  }
}

export default withStyles(styles)(DatetimeGraph);
